<template>
  <div>
    <caasWeb v-if="!isMobile"></caasWeb>
    <caasMobile v-if="isMobile"></caasMobile>
  </div>
</template>
<script>
import caasWeb from './Caas-web.vue'
import caasMobile from './Caas-mobile.vue'
export default {
  name: 'cass',
  data() {
    return {
      isMobile: true
    }
  },
  components: {
    caasWeb,
    caasMobile
  },
  mounted() {
    const detectDeviceType = () =>
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
        ? 'Mobile'
        : 'Desktop'
    this.isMobile = detectDeviceType() === 'Mobile'
  },
  methods: {}
}
</script>
<style lang="less">
</style>
